import { Stack } from '@mantine/core';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPlaceholder } from '../../../../../components/content-placeholder/content-placeholder';
import { useMilestonesTabStore } from '../../../../../store/strategy-store/strategy-store';
import { MainSectionHeader } from './main-section-header';
import { MilestoneProgressChart } from './milestone-progress-chart/milestone-progress-chart';

export const MainSection = () => {
  const i18n = useTranslation();
  const selectedMilestone = useMilestonesTabStore((state) => state.selectedMilestone);
  const milestones = useMilestonesTabStore((state) => state.milestones);

  const chartRef = useRef<HTMLDivElement>(null!);

  if (!selectedMilestone && milestones.length === 0) {
    return <ContentPlaceholder icon="add_circle_outline" text={i18n.t('strategy.milestones.add_to_get_started')} />;
  } else if (!selectedMilestone) {
    return <ContentPlaceholder icon="search_off" text={i18n.t('strategy.milestones.select_to_view_details')} />;
  }

  return (
    <Stack h="100%" style={{ overflow: 'hidden' }}>
      <MainSectionHeader chartRef={chartRef} />
      <MilestoneProgressChart ref={chartRef} />
    </Stack>
  );
};
